export default {"src":"/_next/static/media/Discord_Icon.a3ac78bb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};